// @ vendors
const React = require("react");
const PropTypes = require("prop-types");
const { withRouter } = require('react-router-dom');

// @utils
const { formatText } = require("core/i18n").i18n;
const typeDoc = require("utilities/typeDocument");
const {
    isDisasterRecoveryMode,
} = require("utilities/contactCenter/disasterRecoveryhelper");
const { isPrintOfficeMode } = require('utilities/contactCenter/printerHelper');

// @ commons
const { ModalCustom } = require("commonsComponents/modalCustom");
const { OKButton } = require("components/commons/OKButton/OKButton");
const { FormattedText } = require("core/i18n").i18n;
const { OKCover } = require("commonsComponents/OKCover");
const Wizard = require("components/commons/wizard/wizard");
const WizardStep = require("components/commons/wizardStep/wizardStep");
const OKHeaderLanding = require("components/commons/OKHeaderLanding/OKHeaderLanding");

// @components
const { LoadingSection } = require("commonsComponents/loadingSection");
const CustomMessageBox = require("components/contactCenter/customMessageBox/customMessageBox");
const BlockInfo = require("components/contactCenter/blockInfo/blockInfo");
const OKHeaderCC = require("components/commons/OKHeaderCC/OKHeaderCC");
const VerifyOtpStep = require("components/commons/verifyOtpStep/verifyOtpStep");
const WizardError = require("components/commons/wizardError/wizardError");

const {
    WIZARD_HORIZONTAL_VIEW_MODE,
    WIZARD_SECOND_STEP,
    WIZARD_THIRD_STEP
} = require("constants/index");
const { GAP_OPERATION_ID } = require("constants/contactCenter/operationTypes");

require("./KeysSendView.scss");
const KeysCCStep1 = require("./KeysCCStep1/KeysCCStep1");
const KeysCCStep2 = require("./KeysCCStep2/KeysCCStep2");

class KeysSendView extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            showModal: false,
            otpCode: "",
            showModalCancel: false
        };
        this.handleRequestCodeClick = this.handleRequestCodeClick.bind(this);
        this.handleToggleShowModal = this.handleToggleShowModal.bind(this);
        this.handleGoBack = this.handleGoBack.bind(this);
        this.handleEndInteraction = this.handleEndInteraction.bind(this);
        this.handleRequestOTPCodeChange = this.handleRequestOTPCodeChange.bind(this);
        this.handleGoBackDisasterRecovery = this.handleGoBackDisasterRecovery.bind(this);
    }

    componentWillMount() {
        const { immProfileFields, requestProfile, immUserData, history } = this.props;
        const hasMobile = !!immUserData.getIn(["data", "movil"]);
        const documentType = immProfileFields.getIn([
            "documentoIdentificacion",
            "tipodocumpersonacorp"
        ]);
        const documentNumber = immProfileFields.getIn([
            "documentoIdentificacion",
            "codigodocumpersonacorp"
        ]);

        if (
            !immProfileFields.getIn([
                "documentoIdentificacion",
                "tipodocumpersonacorp"
            ])
        ) {
            requestProfile(history);
        } else if (!hasMobile) {
            if (!!documentType && !!documentNumber) {
                this.props.requestPhoneOTP(documentType, documentNumber);
            }
        }
    }

    componentWillReceiveProps(nextProps) {
        const immCodeOTPData = nextProps.immCodeOTPData;
        const hasMobile = !!nextProps.immUserData.getIn(["data", "movil"]);
        const hasUserDataError = !!nextProps.immUserData.get("error");
        const documentType = nextProps.immProfileFields.getIn([
            "documentoIdentificacion",
            "tipodocumpersonacorp"
        ]);
        const documentNumber = nextProps.immProfileFields.getIn([
            "documentoIdentificacion",
            "codigodocumpersonacorp"
        ]);

        if (
            immCodeOTPData.get("hasBeenSent") &&
            !immCodeOTPData.get("isFetching") &&
            !immCodeOTPData.get("error")
        ) {
            this.props.setVisibleStep(WIZARD_THIRD_STEP);
        }

        if (!hasUserDataError && !hasMobile) {
            if (!!documentType && !!documentNumber) {
                this.props.requestPhoneOTP(documentType, documentNumber);
            }
        } else {
            const hasError = !!nextProps.immCodeOTPData.get("error");

            if (this.state.showModal != hasError) {
                this.setState({ showModal: hasError });
            }
        }
    }

    buildCustomMessageBoxSuccess() {
        const title = formatText("profileKeysLanding-titleMessageBoxSuccess");
        const extraContent = (
            <BlockInfo>
                {formatText("profileKeysLanding-extraContentMessageBox")}
            </BlockInfo>
        );
        const textLink = formatText(
            "addImposition-disasterRecoveryConfirmationBackbtn"
        );

        return (
            <CustomMessageBox
                icon="icon-success"
                title={title}
                extraContent={extraContent}
                textLink={isDisasterRecoveryMode() ? textLink : "  "}
                goBackHandler={
                    isDisasterRecoveryMode()
                        ? this.handleGoBackDisasterRecovery
                        : "&nspb"
                }
            />
        );
    }

    buildCustomMessageBoxFailure() {
        const { immUserData } = this.props;
        const title = formatText("profileKeysLanding-titleMessageBoxFailure");
        const subtitle =
            immUserData.get("error") !== ""
                ? immUserData.getIn([
                    "error",
                    "error",
                    "description",
                    "0",
                    "descripcion"
                ])
                : formatText("profileKeysLanding-subtitleMessageBoxFailure");
        const textLink = isDisasterRecoveryMode()
            ? formatText("addImposition-disasterRecoveryConfirmationBackbtn")
            : formatText(
                "profileKeysLanding-textLinkMessageBoxFailure"
            ).toUpperCase();
        const goBackHandler = isDisasterRecoveryMode()
            ? this.handleGoBackDisasterRecovery
            : this.handleGoBack;
        const goBackText = {
            label: textLink,
            url:
                (isDisasterRecoveryMode() &&
                    "/disasterRecovery/customerFinder") ||
                "/myprofile/global"
        };

        return (
            <WizardError
                errorMessage={title}
                errorSubMessage={subtitle}
                mainButton={goBackText}
            >
                <OKButton onClick={goBackHandler}>
                    <FormattedText value="passwordPositions-refetchConfig" />
                </OKButton>
            </WizardError>
        );
    }

    handleToggleShowModal() {
        this.setState(
            {
                showModal: !this.state.showModal
            },
            () => {
                this.props.requestResetError();
                this.errorOnSendOTPIsAValidOTPReadyToGo() && this.goToStep2();
            }
        );
    }

    goToStep2 = () => this.props.requestStepSuccess(WIZARD_SECOND_STEP);

    handleRequestCodeClick() {
        this.props.requestcodeOTP();
    }

    handleGoBack() {
        this.props.requestcodeOTPReset();
        this.props.requestSendKeyReset();
        this.props.setVisibleStep(WIZARD_SECOND_STEP);
    }

    handleGoBackDisasterRecovery() {
        this.props.history.push("/disasterRecovery/customerFinder");
    }

    buildEndInteractionBlock() {
        const textEndInteraction = formatText(
            "addImposition-disasterRecoveryConfirmationBackbtn"
        );
        return (
            <div className="customer-finder__end-interaction-block">
                <div className="customer-finder__end-interaction-button-container">
                    <div className="customer-finder__end-interaction-button no-print-out">
                        <OKButton
                            modifier="link-complementary"
                            size="small"
                            onClick={this.handleEndInteraction}
                        >
                            <span className="customer-finder__end-interaction-link">
                                {textEndInteraction}
                            </span>
                        </OKButton>
                    </div>
                </div>
            </div>
        );
    }

    handleEndInteraction() {
        this.props.history.push(`/disasterRecovery/customerFinder`);
    }

    handleCancelClick = () => {
        this.props.setVisibleStep(1);
        this.handleToggleCancelModal();
    };

    handleToggleCancelModal = () => {
        const { showModalCancel } = this.state;

        this.setState({
            showModalCancel: !showModalCancel
        });
    };

    handleRequestOTPCodeChange(otpCode) {
        this.setState({ otpCode });
    }

    getNextAction = () => {
        const { immKeysData, validateSignaturePattern } = this.props;

        const fn = {
            [immKeysData.get("visibleStep") === 1]: validateSignaturePattern,
            [immKeysData.get("visibleStep") === 2]: this.handleRequestCodeClick
        }[true];

        fn && fn();
    };

    handleContent() {
        const {
            immProfileFields,
            immUserData,
            immCodeOTPData,
            immKeysData,
            requestSendKey,
            setVisibleStep,
            immSignaturePattern,
            immPrinter
        } = this.props;
        const phoneUser = immUserData.get("data").get("movil");
        const isFetchingCodeOTP = immCodeOTPData.get("isFetching");
        const isFetchingSendKey = immKeysData.get("isFetching");
        const isFetchingUserData = immUserData.get("isFetching");
        const errorUserData = immUserData.get("error");
        const errorSendKey = immKeysData.get("error");
        const recoveryKeyError = immKeysData.get("feedback");
        const hasBeenSentOTP = immCodeOTPData.get("hasBeenSent");
        const hasBeenSentKey = immKeysData.get("hasBeenSent");
        const onHandlerSendCode = this.handleRequestCodeClick;
        const onHandlerSendOTPCode = this.handleRequestOTPCodeChange;
        const isFetching = immUserData.get("isFetching");
        const isFetchingProfile = immProfileFields.get("isFetching");
        const messageBox = this.buildCustomMessageBoxSuccess();
        const messageBoxFail = this.buildCustomMessageBoxFailure();
        const titleStep1 = formatText("keysCCStep1-title");
        const titleStep2 = formatText("keysCCStep2-title");
        const typeDocu = immProfileFields
            .get("documentoIdentificacion")
            .get("tipodocumpersonacorp");
        const typeDocument = typeDoc.getLabel(typeDocu);
        const typeDocSpecific = typeDocument.label;
        const numerDocument = immProfileFields
            .get("documentoIdentificacion")
            .get("codigodocumpersonacorp");
        const currentStep = immUserData.get("step");
        const immSteps = immKeysData.get("steps");
        const visibleStep = immKeysData.get("visibleStep");

        // @TODO
        // 1. Borrar props no usadas en ccstep1 y ccstep2

        let content;

        if (isFetching || isFetchingProfile) {
            content = <LoadingSection />;
        } else if (hasBeenSentOTP && hasBeenSentKey) {
            content = messageBox;
        } else if (
            (hasBeenSentOTP && !hasBeenSentKey && errorSendKey != "") ||
            errorUserData != ""
        ) {
            content = messageBoxFail;
        } else {
            const actions = {
                finish: () => this.props.requestSendKey(this.state.otpCode),
                setVisibleStep,
                validateStep: this.getNextAction,
                setWillCancel: () => { },
                cancel: this.handleToggleCancelModal
            };
            const acceptText = formatText("broker-stocksBuyFinish");
            const sendOtpText = formatText("keysCCStep1-sendOtpCodeButton");
            const enableButtonInOffice =
                immPrinter.get("documentsPrintedAndSigned") === "YES" &&
                immPrinter.get("showPrintedDocumentsConfirmation");
            const enableButtonInCC =
                !immSignaturePattern.get("isFetchingConfigError") &&
                immSignaturePattern.get("consumerFinishInputDigits");
            const nextBtnEnabled = isPrintOfficeMode() ? enableButtonInOffice : enableButtonInCC;

            content = (
                <section>
                    <Wizard
                        viewMode={WIZARD_HORIZONTAL_VIEW_MODE}
                        actions={actions}
                        immSteps={immSteps}
                        stepsAmount={immSteps.size}
                        visibleStep={visibleStep}
                    >
                        <WizardStep
                            cancelButton={false}
                            rightIconModifier={false}
                            nextButtonDisabled={!nextBtnEnabled}
                            isLoading={immSignaturePattern.get(
                                "isFetchingSignaturePassCode"
                            )}
                            nextBtnModifier="primary"
                            nextButtonCustomText={acceptText}
                            position="first"
                        >
                            <VerifyOtpStep
                                operationType={GAP_OPERATION_ID}
                                operationParams={{}}
                            />
                        </WizardStep>
                        <WizardStep
                            position="first"
                            nextButtonCustomText={sendOtpText}
                            cancelButton={true}
                            goBackButton={false}
                            isLoading={isFetchingCodeOTP}
                            nextButtonDisabled={isFetchingCodeOTP}
                        >
                            <KeysCCStep1
                                documentNumer={numerDocument}
                                documentType={typeDocSpecific}
                                mobileNumber={phoneUser}
                                requestCodeOTP={onHandlerSendCode}
                                isFetching={isFetchingCodeOTP}
                                hasBeenSent={hasBeenSentOTP}
                                titleStep={titleStep1}
                                isFetchingUserData={isFetchingUserData}
                                currentStep={currentStep}
                                isDisaster={isDisasterRecoveryMode()}
                            />
                        </WizardStep>
                        <WizardStep
                            position="last"
                            omitPreviousButton={true}
                            isLoading={isFetchingSendKey || isFetchingCodeOTP}
                            finalButtonDisabled={
                                isFetchingSendKey ||
                                isFetchingCodeOTP ||
                                this.state.otpCode.length < 4
                            }
                            cancelButton={true}
                            ccDefaultBehaviour={true}
                            immFinalButton="keysCCStep2-sendKeyButton"
                        >
                            <KeysCCStep2
                                isFetching={isFetchingSendKey}
                                isFetchingOTP={isFetchingCodeOTP}
                                requestKey={requestSendKey}
                                requestCodeOTP={onHandlerSendCode}
                                hasBeenSent={hasBeenSentOTP}
                                hasError={errorSendKey}
                                inlineErrorMessage={recoveryKeyError}
                                immProfileFields={immProfileFields}
                                titleStep={titleStep2}
                                currentStep={currentStep}
                                isDisaster={isDisasterRecoveryMode()}
                                setOTPCode={onHandlerSendOTPCode}
                            />
                        </WizardStep>
                    </Wizard>
                    {isDisasterRecoveryMode() &&
                        this.buildEndInteractionBlock()}
                </section>
            );
        }
        return content;
    }

    buildCancelModal = () => {
        const { showModalCancel } = this.state;

        return (
            <ModalCustom
                shouldCloseOnOverlayClick={false}
                isOpen={showModalCancel}
                extraClass="keyscc-view__cancel-modal"
                onRequestClose={this.handleToggleCancelModal}
            >
                <header className="keyscc-view__cancel-modal__header">
                    <span className="keyscc-view__cancel-modal__header__title">
                        <FormattedText value="profileKeysLanding-cancelModalTitle" />
                    </span>
                </header>
                <footer className="keyscc-view__cancel-modal__footer">
                    <div className="row">
                        <div className="col-xs-6 keyscc-view__cancel-modal__footer__button-left">
                            <OKButton
                                modifier="secondary"
                                onClick={() => this.handleToggleCancelModal()}
                            >
                                <FormattedText value="profileKeysLanding-cancelModalExitButton" />
                            </OKButton>
                        </div>
                        <div className="col-xs-6 keyscc-view__cancel-modal__footer__button-right">
                            <OKButton onClick={() => this.handleCancelClick()}>
                                <FormattedText value="profileKeysLanding-cancelModalAcceptButton" />
                            </OKButton>
                        </div>
                    </div>
                </footer>
            </ModalCustom>
        );
    };

    errorOnSendOTPIsAValidOTPReadyToGo = () => {
        const { immCodeOTPData } = this.props;
        return (
            immCodeOTPData.getIn(["error", "description", 0, "codigo"], "") ===
            "410071"
        );
    };

    buildErrorSendCodeModal() {
        const { immCodeOTPData } = this.props;
        const isFetchingCodeOTP = immCodeOTPData.get("isFetching");
        const modalHeader = formatText(
            `profileKeysLanding-${this.errorOnSendOTPIsAValidOTPReadyToGo()
                ? "modalBodyOTPCodeValid"
                : "modalHeader"
            }`
        );
        const modalButtonText = formatText(
            this.errorOnSendOTPIsAValidOTPReadyToGo()
                ? "sendOtpStep-sendOtpCodeButton"
                : "profileKeysLanding-modalButtonText"
        );
        const callback = this.errorOnSendOTPIsAValidOTPReadyToGo()
            ? this.handleToggleShowModal.bind(this)
            : this.handleRequestCodeClick.bind(this);
        const errorCode = immCodeOTPData.getIn([
            "error",
            "description",
            0,
            "codigo"
        ]);
        let modalBody = "";

        switch (errorCode) {
            // description Required field
            case "410002":
                modalBody = formatText(
                    "profileKeysLanding-modalBodyRequiredField"
                );
                break;
            // description Codigo OTP Vigente
            case "410071":
                modalBody = formatText(
                    "signaturePattern-confirmationCodeSubtitle"
                );
                break;
            // description OTP_NUM_VECES_OTP_GENERADO_SUPERADO
            case "410072":
                modalBody = formatText(
                    "profileKeysLanding-modalBodyExceededOTPGenerations"
                );
                break;
            // description OTP_ERR_INTENTOS_OTP_SUPERADO
            case "410080":
                modalBody = formatText(
                    "profileKeysLanding-modalBodyOTPExceededCodeIncorrect"
                );
                break;
            // description OTP_ERR_OTP_INCORRECTO
            case "410082":
                modalBody = formatText(
                    "profileKeysLanding-modalBodyOTPCodeIncorrect"
                );
                break;
            default:
                modalBody = formatText("profileKeysLanding-modalBody");
                break;
        }

        return (
            <ModalCustom
                shouldCloseOnOverlayClick={false}
                isOpen={this.state.showModal}
                extraClass="keyscc-view__modal"
                onRequestClose={this.handleToggleShowModal}
            >
                <header className="keyscc-view__modal-header">
                    {modalHeader}
                </header>
                <section className="keyscc-view__section">
                    <p className="keyscc-view__modal-message">
                        <span className="keyscc-view__modal-icon">
                            <i className="icon-error" />
                        </span>
                        <span className="keyscc-view__modal-body">
                            {modalBody}
                        </span>
                    </p>
                </section>
                <footer className="keyscc-view__modal-footer">
                    <div className="pull-right">
                        <OKButton
                            modifier="primary"
                            loading={isFetchingCodeOTP}
                            onClick={callback} // eslint-disable-line
                        >
                            {modalButtonText}
                        </OKButton>
                    </div>
                </footer>
            </ModalCustom>
        );
    }

    buildDisasterRecoveryContent(
        titleHeader,
        mappingBreadcrumb,
        content,
        modal,
        cancelModal
    ) {
        return (
            <div className="keyscc-view keyscc-view--disaster-recovery">
                <OKCover
                    size="small"
                    section="pg"
                    extraClass="keyscc-view__cover"
                >
                    <OKHeaderLanding title="" />
                </OKCover>
                <OKHeaderCC
                    title={titleHeader}
                    breadcrumbConfig={mappingBreadcrumb}
                    showBreadBrumb={true}
                />
                <div className="keyscc-view__body">{content}</div>
                {modal}
                {cancelModal}
            </div>
        );
    }

    render() {
        const titleHeader = formatText("profileKeysLanding-title");
        const modal = this.buildErrorSendCodeModal();
        const cancelModal = this.buildCancelModal();
        const content = this.handleContent();
        const mappingBreadcrumb = [
            ...(!__CONTACT_CENTER__
                ? [
                    {
                        text: titleHeader,
                        url: "/myprofile/keys"
                    }
                ]
                : []),
            {
                text: formatText("profileKeysLanding-requestNewKey")
            }
        ];
        const disasterRecoveryContent = this.buildDisasterRecoveryContent(
            titleHeader,
            mappingBreadcrumb,
            content,
            modal,
            cancelModal
        );

        return isDisasterRecoveryMode() ? (
            disasterRecoveryContent
        ) : (
            <div className="keyscc-view">
                <OKHeaderCC
                    title={titleHeader}
                    breadcrumbConfig={mappingBreadcrumb}
                    showBreadBrumb={true}
                />
                <div className="keyscc-view__body">{content}</div>
                {cancelModal}
                {modal}
            </div>
        );
    }
}

KeysSendView.propTypes = {
    immUserData: PropTypes.object,
    immCodeOTPData: PropTypes.object,
    immKeysData: PropTypes.object,
    immProfileFields: PropTypes.object,
    immSignaturePattern: PropTypes.object,
    immPrinter: PropTypes.object,
    requestcodeOTP: PropTypes.func,
    requestSendKey: PropTypes.func,
    requestPhoneOTP: PropTypes.func,
    requestcodeOTPReset: PropTypes.func,
    requestSendKeyReset: PropTypes.func,
    requestResetError: PropTypes.func,
    requestProfile: PropTypes.func,
    requestStepSuccess: PropTypes.func,
    setVisibleStep: PropTypes.func,
    validateSignaturePattern: PropTypes.func,
    history: PropTypes.object.isRequired,
};

module.exports = withRouter(KeysSendView);
